// extracted by mini-css-extract-plugin
module.exports = {"enabled":"offer-group-form_enabled_2C30P","tags":"offer-group-form_tags_JB-bf","tag":"offer-group-form_tag_1w3GG","msg":"offer-group-form_msg_udMlE"};